var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 163,
    viewBox: "0 0 131 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1476_29720)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1476_29720",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 22,
    width: 107,
    height: 125
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.189 147H22.185C16.5606 147 12 142.454 12 136.846V32.6593C12 27.051 16.5606 22.5045 22.185 22.5045H108.189C113.813 22.5045 118.374 27.051 118.374 32.6593V136.846C118.374 142.454 113.813 147 108.189 147Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1476_29720)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.189 147H22.185C16.5606 147 12 142.454 12 136.846V32.6593C12 27.051 16.5606 22.5045 22.185 22.5045H108.189C113.813 22.5045 118.374 27.051 118.374 32.6593V136.846C118.374 142.454 113.813 147 108.189 147Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1211 97.6826H68.5477V96.4788H60.1211V97.6826Z",
    fill: "#89C0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2202 113.332H76.9739V110.322H28.2202V113.332Z",
    fill: "#89C0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2202 127.777H67.9454V124.768H28.2202V127.777Z",
    fill: "#89C0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2202 120.555H51.6942V117.545H28.2202V120.555Z",
    fill: "#89C0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3496 88.3606H28.8213V98.2846H39.3468V96.764H30.3496V88.3606ZM98.9199 88.3606V96.764H89.9226V98.2846H100.448V88.3606H98.9199ZM28.8223 45.0075H30.3505V36.6059H39.3478V35.0854H28.8223V45.0075ZM89.9226 35.0855V36.6059H98.9199V45.0075H100.448V35.0855H89.9226Z",
    fill: "#89C0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8353 82.0331H86.7755C86.113 77.2091 85.3008 71.7026 85.3008 71.7026C85.3008 71.7026 84.8939 76.247 84.3989 82.0331H44.1477C43.7805 76.8296 43.3384 72.9369 43.1783 72.8575C42.9476 72.7412 41.5112 77.3577 40.3199 82.0331H29.4229C32.2253 69.9416 37.4528 50.5421 40.4756 49.38C44.7763 47.7227 62.3198 42.3079 62.3198 42.3079H72.3312C72.3312 42.3079 90.1199 47.3913 91.7753 52.9181C93.0913 57.3228 95.9937 71.8468 96.8353 82.0331Z",
    fill: "#91D8BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2989 9.89326C68.2989 9.89326 77.6481 11.3592 76.2245 25.9184C74.801 40.4776 66.5492 39.2842 65.9983 39.2695C65.4459 39.2547 57.7142 39.535 57.1118 21.7591C57.1118 21.7591 56.8474 8.61449 68.2989 9.89326Z",
    fill: "#EEA987"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8078 35.4891C71.8078 35.4891 71.5541 41.5868 72.1297 42.9069C72.704 44.2269 64.514 48.467 59.5186 43.7419C59.5186 43.7419 60.725 37.115 60.39 34.7662C60.0536 32.4174 71.8078 35.4891 71.8078 35.4891Z",
    fill: "#EEA987"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2625 22.3384C76.2625 22.3384 77.1916 21.2157 77.5315 22.3523C77.8727 23.4889 76.0905 28.5674 76.2078 28.7953C76.2078 28.7953 76.0372 29.236 75.8146 28.9933C75.592 28.7507 76.2625 22.3384 76.2625 22.3384Z",
    fill: "#EEA987"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6996 21.7521C56.6996 21.7521 55.7384 20.6128 55.3579 21.7381C54.9773 22.8636 56.7687 27.964 56.6418 28.1886C56.6418 28.1886 56.8138 28.6317 57.0534 28.3946C57.293 28.1576 56.6996 21.7521 56.6996 21.7521Z",
    fill: "#EEA987"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3122 24.6052L74.9692 26.4172C74.9692 26.4172 75.0061 22.4448 74.7909 21.822C74.5756 21.1992 74.2454 19.2964 74.0656 18.8476C73.8857 18.399 66.0093 16.1717 59.0512 19.4979C59.0512 19.4979 59.3579 22.3544 58.6915 22.6086C58.0237 22.8628 58.351 27.2607 58.351 27.2607L57.2469 26.0033C57.2469 26.0033 55.556 14.6078 55.9732 13.42C56.3919 12.2323 57.7215 5.09142 71.9944 9.33047C71.9944 9.33047 76.4449 8.37937 77.3382 11.4795C78.2316 14.5794 76.3122 24.6052 76.3122 24.6052Z",
    fill: "#D98B52"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5465 42.3534C72.5465 42.3534 74.5973 42.8073 66.0155 51.3363C66.0155 51.3363 59.9287 44.3536 60.1258 43.1841C60.3229 42.0147 72.5465 42.3534 72.5465 42.3534Z",
    fill: "#EEA987"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1392 51.386L68.5675 55.5498L75.7695 43.2859L72.6497 41.1042L66.1392 51.386Z",
    fill: "#24B275"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1398 51.4852L60.3776 42.3079L57.1113 44.4092L62.9677 55.5496L66.1398 51.4852Z",
    fill: "#24B275"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1446 77.0966C64.2176 78.4664 64.2503 80.1471 64.2548 82.0332H63.9182C63.9152 80.1545 63.8824 78.4781 63.8094 77.1127C63.2598 66.8103 65.795 54.2745 65.8113 51.3364L66.139 51.4002C66.1226 54.3381 63.5949 66.8384 64.1446 77.0966Z",
    fill: "#24B275"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.926 37.8539C61.926 37.8539 64.2242 40.343 67.4708 39.6792C70.7174 39.0153 72.1583 37.4929 72.1583 37.4929C72.1583 37.4929 70.877 40.7848 67.1242 41.0861C63.37 41.3873 61.926 37.8539 61.926 37.8539Z",
    fill: "#C78D71"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.246 112.571C94.7719 112.571 89.5266 117.816 89.5266 124.29C89.5266 130.764 94.7719 136.009 101.246 136.009C107.72 136.009 112.965 130.764 112.965 124.29C112.965 117.816 107.72 112.571 101.246 112.571ZM108.05 125.613C108.05 125.925 107.795 126.18 107.483 126.18H103.136V130.528C103.136 130.839 102.881 131.095 102.569 131.095H99.9226C99.6107 131.095 99.3556 130.839 99.3556 130.528V126.18H95.0081C94.6963 126.18 94.4411 125.925 94.4411 125.613V122.967C94.4411 122.655 94.6963 122.4 95.0081 122.4H99.3556V118.052C99.3556 117.74 99.6107 117.485 99.9226 117.485H102.569C102.881 117.485 103.136 117.74 103.136 118.052V122.4H107.483C107.795 122.4 108.05 122.655 108.05 122.967V125.613Z",
    fill: "#91D8BA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1476_29720",
    x: 0,
    y: 0,
    width: 130.374,
    height: 163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1476_29720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1476_29720",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.449852bc0cdf159b460a17b9f6129552.svg";
export { ForwardRef as ReactComponent };